// extracted by mini-css-extract-plugin
module.exports = {"suffix":"Suffix--suffix--T4IZF","icon":"Suffix--icon--2Hzdy","disabled":"Suffix--disabled--25b_H"};